import { CrossSell } from '~domain/entities/CrossSell';
import { Product } from '~domain/entities/Product';

const ensureCrossSellOrder = (crossSellItems: CrossSell[]) =>
    crossSellItems.sort((a, b) => a.sortKey - b.sortKey);

export const sortByCrossSellOrder = (products: Product[], crossSellItems: CrossSell[]) =>
    ensureCrossSellOrder(crossSellItems)
        .map(
            (crossSellItem) =>
                products.find((product) =>
                    product.skus.some((sku) => sku.skuId === crossSellItem.skuId)
                ) as Product
        )
        .filter(Boolean);
